import actions from './actions'
import detail from './metaData/feiShuDocumentDetail'
export default {
  state: detail,
  actions
}
